import { recoverSavedState } from '../actions';

class InteractionInterface {
	constructor(loaderAppElement, loaderExternalInterface, store) {
		this.loaderAppElement = loaderAppElement;
		this.loaderExternalInterface = loaderExternalInterface;
		this.store = store;
		this.type = 'AaReadParagraph';
	}
	recoverableState({ currentItem, itemsMarkedText }) {
		let recoverable = false;
		const { exercise } = this.store.getState();
		const itemsLength = exercise.items.length;

		if (
			(currentItem === null || currentItem < itemsLength) &&
			(itemsMarkedText.length <= itemsLength)
		) {
			recoverable = true;
		}

		return recoverable;
	}
	recoverSavedState(recoveriesCount, learnerResponse) {
		this.store.dispatch(recoverSavedState(learnerResponse));
	}
	getContainer() {
		return this.loaderAppElement;
	}
	updateInteraction(learnerResponse) {
		const {
			exercise: { currentItem, resultsVisible, questionsAnswered, wordsPerMinute, wordsRecognisedPercent, itemsMarkedText },
			feedback,
			loader: { testSent, itemsWithAudio }
		} = this.store.getState();

		learnerResponse.currentItem = currentItem;
		learnerResponse.resultsVisible = resultsVisible;
		learnerResponse.itemsMarkedText = itemsMarkedText;
		learnerResponse.questionsAnswered = questionsAnswered;
		learnerResponse.feedback = feedback.map(e => ((e && e.type !== 'recording' && e.type !== 'analysis') ? e : undefined));
		learnerResponse.testSent = testSent;
		learnerResponse.itemsWithAudio = itemsWithAudio;
		learnerResponse.wordsPerMinute = wordsPerMinute;
		learnerResponse.wordsRecognisedPercent = wordsRecognisedPercent;
		if (window.OVERRIDE_XML) console.log(JSON.stringify(learnerResponse));
	}
	hasLoaded() {
		return this.loaderExternalInterface.appLoaded;
	}
	getVersion() {
		return this.store.getState().loader.version;
	}
	getType() {
		return this.type;
	}
}

export default InteractionInterface;
